import { useMutation } from '@tanstack/react-query'
import { baseUrl } from 'api/config'
import axios from 'axios'
import { useSnackbarContext } from '../../context/SnackbarProvider/SnackbarProvider'

const resolveDeal = async ({ PK, SK, requestor, approverId, resolution }) => {
  try {
    const slackToken = localStorage.getItem('slack_access_token')
    if (!slackToken) {
      throw new Error('No authentication token available')
    }

    const response = await axios.post(
      `${baseUrl}/aws/organizations_table/${PK}/${SK}/resolve`,
      { requestor, approverId, resolution, slackToken },
      {
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          Authorization: slackToken,
        },
      }
    )
    return response.data
  } catch (error) {
    console.error('Error approving the deal:', error)
    throw error
  }
}

export const useResolveDeal = () => {
  const { showSnackbar } = useSnackbarContext()

  const mutation = useMutation({
    mutationFn: resolveDeal,
    onSuccess: data => {
      console.log('Deal resolved successfully:', data)
      showSnackbar('Deal resolved successfully', 'success')
    },
    onError: error => {
      console.error('Error in deal approval process:', error)
      showSnackbar('Error during approval', 'error')
    },
  })
  return mutation
}
